export default __webpack_public_path__ + "static/media/car-door-light.3a628392.png";